<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Edit Rewards Program</h1>
    </div>
    <div class="container admin-users">
      <br>
      <div
        v-if="!programId"
        class="alert alert-danger">
        Program ID not found. Please return to the dashboard and reselect a program to edit.
        <br>
        <router-link :to="{name: 'AdminDashboard'}">Return to dashboard</router-link>
      </div>
      <h1 v-else class="text-center text-uppercase">{{ program.name }}</h1>
      <br>

      <button class="btn blue-outline-dark view-as" @click="viewModal = true">View As</button>

      <div class="blue-outline-dark">
        <div class="row">
          <div class="col-sm-5"><strong>Start Date: {{ formattedDate(program.startDate) }} | End Date: {{ formattedDate(program.endDate) }}</strong></div>
          <div class="col-sm-7 text-right">
            <router-link :to="{ name: 'EditLoyaltyProgramDetails' }">EDIT PROGRAM</router-link>
          </div>
        </div>
      </div>

      <div class="blue-outline-nh light-grey-type">
        <div class="row">
          <div class="col-sm-4">Approved Users</div>
          <div class="col-sm-4"><strong class="blue-type">{{ approvedUsers.length }}</strong></div>
          <!-- <div class="col-sm-4 text-right"><a href="#"><strong>View All</strong></a></div> -->
          <div class="col-sm-4 text-right">
            <a href="" class="admin-clickable" @click.prevent="addUser = true"><strong>Add</strong></a> |
            <a href="" class="admin-clickable" @click.prevent="goApprovedUsers"><strong>View All</strong></a>
          </div>
        </div>
      </div>

      <div class="blue-outline-nh light-grey-type">
        <div class="row">
          <div class="col-sm-4">Approved Rebate Submissions</div>
          <div class="col-sm-4"><strong class="blue-type">{{ approvedReceipts.length }}</strong></div>
          <div class="col-sm-4 text-right"><a href="" class="admin-clickable" @click.prevent="goApprovedRebates"><strong>View All</strong></a></div>
        </div>
      </div>

      <div class="blue-outline-nh light-grey-type">
        <div class="row">
          <div class="col-sm-4">Unapproved Users</div>
          <div class="col-sm-4"><strong class="blue-type">{{ unapprovedUsers.length }}</strong></div>
          <div class="col-sm-4 text-right"><a href="" class="admin-clickable" @click.prevent="goUnapprovedUsers"><strong>View All</strong></a></div>
        </div>
      </div>

      <div class="blue-outline-nh light-grey-type">
        <div class="row">
          <div class="col-sm-4">Unapproved Rebate Submissions</div>
          <div class="col-sm-4"><strong class="blue-type">{{ unapprovedReceipts.length }}</strong></div>
          <div class="col-sm-4 text-right"><a href="" class="admin-clickable" @click.prevent="goUnapprovedRebates"><strong>View All</strong></a></div>
        </div>
      </div>

      <div class="blue-outline-nh light-grey-type">
        <div class="row">
          <div class="col-sm-4">Training Modules Completed</div>
          <div class="col-sm-4"><strong class="blue-type">{{ completedTrainingsCount }}</strong></div>
          <div class="col-sm-4 text-right">
            <router-link :to="{ name: 'CompletedTrainings' }" class="admin-clickable"><strong>View All</strong></router-link>
          </div>
        </div>
      </div>

      <div class="blue-outline-nh light-grey-type">
        <div class="row">
          <div class="col-sm-4">Submitted Reward Items</div>
          <div class="col-sm-4"><strong class="blue-type">{{ unsentRewardItemsCount }} / {{ totalRewardItemsCount }}</strong></div>
          <div class="col-sm-4 text-right">
            <router-link :to="{ name: 'RewardItemSubmissions' }" class="admin-clickable"><strong>View All</strong></router-link>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <br>

      <div class="row">
        <div class="col-sm-6">
          <a
            @click.prevent="exportUsersToCSV"
            href=""
            type="button"
            class="btn admin-btn-primary btn-lg btn-block">
            Export All Users to CSV
          </a><br>
        </div>

        <div class="col-sm-6">
          <a
            @click.prevent="exportRebateSubmissionsToCSV"
            href=""
            type="button"
            class="btn admin-btn-primary btn-lg btn-block">
            Export All Rebate Submissions to CSV
          </a><br>
        </div>

        <div class="col-sm-6">
          <a
            @click.prevent="exportTrainingsToCSV"
            href=""
            type="button"
            class="btn admin-btn-primary btn-lg btn-block">
            Export All Training to CSV
          </a><br>
        </div>

        <div class="col-sm-6">
          <a
            @click.prevent="exportRewardItemsToCSV"
            href=""
            type="button"
            class="btn admin-btn-primary btn-lg btn-block">
            Export All Reward Items to CSV
          </a><br>
        </div>
      </div>

      <br><br>
    </div><!-- container-fluid -->
    <add-user-modal :addUser="addUser" v-on:close="addUser = false"></add-user-modal>
    <view-as-modal :viewModal="viewModal" v-on:close="viewModal = false"></view-as-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import AddUserModal from '../../components/admin/addUserModal/AddUserModal'
import ViewAsModal from '../../components/admin/ViewAsModal'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

export default {
  name: 'EditLoyaltyProgram',
  data () {
    return {
      addUser: false,
      viewModal: false
    }
  },
  components: {
    'add-user-modal': AddUserModal,
    'view-as-modal': ViewAsModal
  },
  computed: {
    ...mapGetters('loyaltyProgram', [
      'completedTrainingsCount',
      'programId',
      'approvedReceiptItems',
      'unapprovedReceiptItems',
      'unapprovedReceipts',
      'approvedReceipts'
    ]),
    ...mapState('loyaltyProgram', [
      'program',
      'receiptItems'
    ]),
    approvedUsers () {
      return this.program.userLoyaltyPrograms.filter(userProgram => userProgram.approved && !userProgram.disabled)
    },
    unapprovedUsers () {
      return this.program.userLoyaltyPrograms.filter(userProgram => !userProgram.approved)
    },
    unsentRewardItemsCount () {
      return this.program.userLoyaltyPrograms.reduce((unsent, ulp, idx) => {
        unsent += ulp.cart.filter(cartItem => !cartItem.shipped).length
        return unsent
      }, 0)
    },
    totalRewardItemsCount () {
      return this.program.userLoyaltyPrograms.reduce((unsent, ulp, idx) => {
        unsent += ulp.cart.length
        return unsent
      }, 0)
    }
  },
  mounted () {
    this.getLoyaltyProgramBySlug(this.programId)
      .then((loyaltyProgram) => {
        return this.getReceiptsByLoyaltyProgramId(this.programId)
      })
      .then((results) => {
        // console.log(results)
      })
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug',
      'getReceiptsByLoyaltyProgramId'
    ]),
    ...mapActions('user', [
      'getUsersById'
    ]),
    formattedDate (date) {
      return moment(date).format('MM/DD/YYYY').toString()
    },
    goApprovedUsers () {
      this.getUsersById({ userIds: this.approvedUsers.map(userProgram => userProgram.user._id) })
        .then(() => {
          this.$router.push({ name: 'ApprovedUsers' })
        })
    },
    goUnapprovedUsers () {
      this.getUsersById({ userIds: this.unapprovedUsers.map(userProgram => userProgram.user._id) })
        .then(() => {
          this.$router.push({ name: 'UnapprovedUsers' })
        })
    },
    goApprovedRebates () {
      this.$router.push({ name: 'ApprovedRebateSubmissions' })
    },
    goUnapprovedRebates () {
      this.$router.push({ name: 'UnapprovedRebateSubmissions' })
    },
    exportUsersToCSV () {
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${this.programId}/exportUsers`)
        .then(response => {
          window.URL = window.webkitURL || window.URL
          const contentType = 'text/csv'
          const csvFile = new Blob([response.data], { type: contentType })

          const a = document.createElement('a')
          a.download = 'Users.csv'
          a.href = window.URL.createObjectURL(csvFile)
          a.click()
          a.remove()
        })
        .catch(err => {
          console.log(err)
        })
    },
    exportTrainingsToCSV () {
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${this.programId}/exportTrainings`)
        .then(response => {
          window.URL = window.webkitURL || window.URL
          const contentType = 'text/csv'
          const csvFile = new Blob([response.data], { type: contentType })

          const a = document.createElement('a')
          a.download = 'CompletedTrainings.csv'
          a.href = window.URL.createObjectURL(csvFile)
          a.click()
          a.remove()
        })
        .catch(err => {
          console.log(err)
        })
    },
    exportRebateSubmissionsToCSV () {
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${this.programId}/exportRebateSubmissions`)
        .then(response => {
          window.URL = window.webkitURL || window.URL
          const contentType = 'text/csv'
          const csvFile = new Blob([response.data], { type: contentType })

          const a = document.createElement('a')
          a.download = 'RebateSubmissions.csv'
          a.href = window.URL.createObjectURL(csvFile)
          a.click()
          a.remove()
        })
        .catch(err => {
          console.log(err)
        })
    },
    exportRewardItemsToCSV () {
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/program/${this.programId}/exportRewardSubmissions`)
        .then(response => {
          console.log(response.data)
          window.URL = window.webkitURL || window.URL
          const contentType = 'text/csv'
          const csvFile = new Blob([response.data], { type: contentType })

          const a = document.createElement('a')
          a.download = 'RewardItems.csv'
          a.href = window.URL.createObjectURL(csvFile)
          a.click()
          a.remove()
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
.view-as:hover {
  color: white;
  text-decoration: underline;
}
</style>
